import { Button, Spinner, Tooltip } from 'gu-ui-kit'
import PropTypes from 'prop-types'
import React, { useCallback, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { ACCOUNT_ARCHIVE } from 'modules/Services/types'

export const ArchiveButton = ({ id, title, startIcon = '', handleClick, name, ...rest }) => {
  const [processing, setProcessing] = useState(false)
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const handleButtonClick = useCallback(() => {
    if (processing) {
      return
    }

    setProcessing(true)

    new Promise((resolve, reject) => {
      dispatch({
        type: ACCOUNT_ARCHIVE,
        payload: {
          ids: [Number(id)],
          title: t('services::account_list.confirm_archive_account.heading'),
          text: t('services::account_list.confirm_archive_account.summary', {
            name,
          }),
        },
        meta: { resolve, reject },
      })
    }).finally(() => setProcessing(false))

    handleClick()
  }, [setProcessing, id, processing])

  return (
    <Tooltip
      title={title}
      placement="bottom"
      leaveDelay={250}
      arrow
    >
      <Button
        onClick={handleButtonClick}
        {...rest}
        startIcon={processing ? <Spinner width={24} /> : startIcon}
      >
        {title}
      </Button>
    </Tooltip>
  )
}

ArchiveButton.propTypes = {
  action: PropTypes.string,
  id: PropTypes.string,
  login: PropTypes.string,
  startIcon: PropTypes.node,
  className: PropTypes.string,
  color: PropTypes.string,
  variant: PropTypes.string,
  title: PropTypes.string,
  handleClick: PropTypes.func,
  name: PropTypes.string,
}
